import { GenericEntity } from './common.model';

export class LoginRequest {
    username: string;
    password: string;
}

export class SystemUser extends GenericEntity {
    username: string;
    fullName: string;
    activeCharacter: SystemUserCharacter;
    characters: SystemUserCharacter[];
    entityRole: EntityRole;
    timetableAccess: boolean;
    frontierAccess: boolean;
}

export class SystemUserCharacter {
    active: boolean;
    entityVersion: number;
    role: EntityRole;
    name: string;
}

export enum EntityRole {
    WORKER = 'WORKER',
    AGENT = 'AGENT',
    DIRECT_SALES = 'DIRECT_SALES',
    HEADQUATERS = 'HEADQUATERS',
    SALES_MANAGER = 'SALES_MANAGER'
}
